export const fmtPrice = (v, digits = 2) =>
  v == null || isNaN(v) ? "—" : Number(v).toLocaleString("en-US", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  });

export const fmtUsd = (v, digits = 2) =>
  v == null || isNaN(v) ? "—" : `$${fmtPrice(v, digits)}`;

export const fmtSignedUsd = (v, digits = 2) => {
  if (v == null || isNaN(v)) return "—";
  const n = Number(v);
  const sign = n > 0 ? "+" : n < 0 ? "" : "";
  return `${sign}$${fmtPrice(Math.abs(n), digits)}` .replace("+$-", "-$");
};

export const fmtPct = (v, digits = 2) => {
  if (v == null || isNaN(v)) return "—";
  const n = Number(v);
  const sign = n > 0 ? "+" : "";
  return `${sign}${n.toFixed(digits)}%`;
};

export const colorForPnl = (v) => {
  if (v == null || isNaN(v)) return "text-zinc-400";
  if (v > 0) return "text-[#34C759]";
  if (v < 0) return "text-[#FF3B30]";
  return "text-zinc-400";
};

export const shortDate = (s) => {
  if (!s) return "—";
  try {
    const d = new Date(s);
    return d.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return s;
  }
};

/**
 * "5 dk önce", "2 sa önce", "3 gün önce" gibi Türkçe göreceli zaman.
 * 7 günden eski → shortDate'a düşer.
 */
export const relativeTime = (s) => {
  if (!s) return "—";
  try {
    const t = new Date(s).getTime();
    if (isNaN(t)) return s;
    const diff = Math.max(0, Date.now() - t);
    const sec = Math.floor(diff / 1000);
    if (sec < 10) return "şimdi";
    if (sec < 60) return `${sec} sn önce`;
    const min = Math.floor(sec / 60);
    if (min < 60) return `${min} dk önce`;
    const hr = Math.floor(min / 60);
    if (hr < 24) return `${hr} sa önce`;
    const day = Math.floor(hr / 24);
    if (day < 7) return `${day} gün önce`;
    return shortDate(s);
  } catch {
    return s;
  }
};

/**
 * Aktiflik durumuna göre renk sınıfı döndürür.
 *  < 5 dk  → parlak yeşil (canlı)
 *  < 15 dk → yumuşak yeşil
 *  < 1 sa  → muted yeşilimsi
 *  < 24 sa → zinc-400
 *  daha eski → zinc-600 (faint)
 */
export const activityColor = (s) => {
  if (!s) return "text-zinc-600";
  try {
    const diff = Date.now() - new Date(s).getTime();
    if (isNaN(diff) || diff < 0) return "text-zinc-400";
    const min = diff / 60_000;
    if (min < 5) return "text-[#2bd98a] font-semibold";
    if (min < 15) return "text-[#2bd98a]/85";
    if (min < 60) return "text-[#2bd98a]/55";
    if (min < 24 * 60) return "text-zinc-400";
    return "text-zinc-600";
  } catch {
    return "text-zinc-500";
  }
};
